import Splide from '@splidejs/splide';

export default class EssentialsCards extends HTMLElement {

    constructor() {
        super();
    }

    connectedCallback() {
        // Si et seulement si, il existe bien un élément "#essential-cards" dans le DOM alors
        // on initialise splide sur cet élément
        const essentialCardsId = '#essential-cards';
        if ($(essentialCardsId).length) {
            var splide = new Splide(essentialCardsId, {
                type: 'slide',
                perPage: 4,
                omitEnd: true,
                autoplay: true,
                pagination: true,
                isNavigation: true,
                arrows: document.querySelectorAll('.splide__slide').length > 4,
                gap: '1rem',
                breakpoints: {
                    1084: { perPage: 3 },
                    750: {
                        fixedWidth: '16rem',
                    },
                },
            });

            splide.on('mounted', function () {
                // Masquer les flèches si le nombre de slides est inférieur ou égal à 4
                if (splide.Components.Elements.slides.length <= 4) {
                    $('.splide__arrow').addClass('hidden-arrows');
                }
            });

            splide.mount();
        }
    }

}
